import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PoiServiceService {
    private chooseFromInMap:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private chooseToInMap:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }
    setChooseFromInMap(value:boolean){
        this.chooseFromInMap.next(value)
    }

    getChooseFromInMap(): boolean {
        return this.chooseFromInMap.getValue();
    }

    setChooseToInMap(value:boolean){
        this.chooseToInMap.next(value)
    }

    getChooseToInMap(): boolean {
        return this.chooseToInMap.getValue();
    }}
